// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// // Import translations
// import translationEN from "./languages/english.json";
// import translationFR from "./languages/arabic.json";

// // Configure i18n
// i18n
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     resources: {
//       en: {
//         translation: translationEN,
//       },
//       ar: {
//         translation: translationFR,
//       },
//     },
//     lng: "en", // default language
//     fallbackLng: "en", // fallback language if translation not found
//     interpolation: {
//       escapeValue: false, // react already safes from xss
//     },
//   });

// export default i18n;
// i18n.js

// i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en", // Default language
    fallbackLng: "en",
    backend: {
      loadPath: "/locales/en/eng.json", // Adjust the path based on your project structure
      loadPath: "/locales/en/arb.json", // Adjust the path based on your project structure
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: require("./locales/en/eng.json"),
      },
      ar: {
        translation: require("./locales/ar/arb.json"),
      },
    },
  });

export default i18n;
